import { render, staticRenderFns } from "./BannerSlideVantagens.vue?vue&type=template&id=67b6db7f&scoped=true&"
import script from "./BannerSlideVantagens.vue?vue&type=script&lang=js&"
export * from "./BannerSlideVantagens.vue?vue&type=script&lang=js&"
import style0 from "./BannerSlideVantagens.vue?vue&type=style&index=0&id=67b6db7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6db7f",
  null
  
)

export default component.exports